<template>
  <form name="formSearch" @submit.prevent="submit()">
    <SuggestPanel
      v-if="suggestType"
      v-model="internalSearch"
      class="p-form-search__suggest_panel"
      :type="suggestType"
    >
      <InputText
        v-model="internalSearch"
        type="search"
        class="p-form-search__suggest_panel__input"
        name="internalSearch"
        :placeholder="placeholder"
        autocomplete="off"
        :has-icon="true"
      ></InputText>
      <button
        type="submit"
        class="p-form-search__button p-form-search__button--has_saggest"
        :style="{ background: buttonColor }"
        @click="emitSearchMember"
      >
        <i class="p-form-search__button__icon">
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="buttonColor ? '#ffffff' : iconColor"
          >
            <IconSearch :icon-size="24" />
          </IconBase>
        </i>
        <span class="p-form-search__button__text">検索</span>
      </button>
    </SuggestPanel>

    <div v-else class="p-form-search">
      <input
        v-model="internalSearch"
        type="text"
        class="p-form-search__input"
        :placeholder="placeholder"
      />
      <button
        type="submit"
        class="p-form-search__button"
        :style="{ background: buttonColor }"
        @click="emitSearchMember"
      >
        <i class="p-form-search__button__icon">
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="buttonColor ? '#ffffff' : iconColor"
          >
            <IconSearch :icon-size="24" />
          </IconBase>
        </i>
        <span class="p-form-search__button__text">検索</span>
      </button>
    </div>
  </form>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSearch from "@/common/components/icons/IconSearch.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import SuggestPanel from "@/common/components/molecules/SuggestPanel.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    search: { type: String, default: "" },
    placeholder: { type: String, default: "メンバーを探す" },
    suggestType: { type: String, default: "" },
    buttonColor: { type: String, default: "" },
    iconColor: { type: String, default: "#bdbdbd" }
  },
  components: {
    IconBase,
    IconSearch,
    InputText,
    SuggestPanel
  }
})
export default class FormSearch extends Vue {
  search!: string;
  placeholder!: string;
  suggestType!: string;
  buttonColor!: string;
  iconColor!: string;

  emitSearchMember() {
    this.$emit("search-member", {});
  }

  submit() {
    this.$emit("do-search");
  }

  get internalSearch() {
    return this.search;
  }

  set internalSearch(newValue: string) {
    if (this.search !== newValue) this.$emit("update:search", newValue);
  }
}
</script>

<style lang="scss" scoped>
.p-form-search {
  width: 100%;
  border: 1px solid $common-gray300;
  border-radius: rem(4);
  position: relative;
  display: flex;

  &__suggest_panel {
    width: 100%;
    display: flex;

    &__input {
      flex-grow: 1;
      width: 100%;
    }
  }

  &__input {
    flex: 1 1 auto;
    height: rem(38);
    padding: rem(10);
    min-width: 0;
  }

  &__button {
    width: rem(50);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &--has_saggest {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
    }

    &__icon {
      position: relative;
      z-index: 1;
      line-height: 1;
    }

    &__text {
      position: absolute;
      z-index: 0;
      visibility: hidden;
      opacity: 0;
    }
  }
}
</style>
